import { Formik } from "formik";
import moment from "moment";
import { createContext } from "react";

import SchedulePostContent from "./SchedulePostContent";
import SchedulePostFooter from "./SchedulePostFooter";
import SchedulePostHeader from "./SchedulePostHeader";
import { SchedulePostModalProps } from "./SchedulePostModal";
import { scheduledPostUtils } from "./utils";

export const SchedulePostModalContext = createContext(
  {} as SchedulePostModalProps.Context
);
const SchedulePostModal = ({
  setSchedulePostOpen,
  deliveryDate,
  onSubmit,
  title,
}: SchedulePostModalProps.IProps) => {
  const date = deliveryDate
    ? moment(deliveryDate)
    : moment(new Date()).add(1, "hour");

  return (
    <Formik
      initialValues={{
        day: date.format("DD"),
        hour: date.format("HH"),
        minute: date.format("mm"),
        month: date.format("MMMM"),
        year: date.format("YYYY"),
      }}
      onSubmit={onSubmit}
      validationSchema={scheduledPostUtils.schedulePostValidation}
    >
      {(formik) => {
        return (
          <SchedulePostModalContext.Provider
            value={{ formik, setSchedulePostOpen, title }}
          >
            <SchedulePostHeader />
            <SchedulePostContent />
            <SchedulePostFooter />
          </SchedulePostModalContext.Provider>
        );
      }}
    </Formik>
  );
};

export default SchedulePostModal;
